// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","navbar-logo":"Navbar_navbar-logo__+vaot"};